import { Address } from '../../shared/models/address.model';


/**
 * Contact type
 */
export enum ContactType {
  AirportManager,
  Owner
}


/**
 * Airport contact
 */
export class Contact {
  /**
   * Unique identifier for this record in the database
   */
  id: number;

  /**
   * Airport record ID for which this record applies
   */
  airportId: number;

  /**
   * Source ID that identifies the source of this data (e.g., airport manager)
   */
  sourceId: number;

  /**
   * Contat name (e.g., person's name, or municipality for civil-owned airports)
   */
  name: string;

  /**
   * Contact type
   */
  type: ContactType;

  /**
   * Contact phone number
   */
  phoneNumber: string;

  /**
   * Contact phone type (e.g,, "Office")
   */
  phoneType: string;

  /**
   * Contact address
   */
  address: Address;

  /**
   * Contact email address
   */
  email: string;

  /**
   * Parses contact
   * @param data {any} Contact data as returned by API
   * @return {Contact} Parsed contact
   */
  static parse(data: any): Contact {
    return {
      id: data.contactId,
      airportId: data.airportId,
      sourceId: data.sourceId,
      name: data.name,
      type: this.parseContactType(data.deptTitle),
      phoneNumber: data.phoneNumber,
      phoneType: data.phoneType,
      address: Address.parse(data.address1, data.address2, data.city, data.stateProvince, data.zip, data.country),
      email: data.email
    };
  }

  /**
   * Parses contact type
   * @param value {any} Contact type as returned by API
   * @return {ContactType} Parsed contact type
   */
  static parseContactType(value: any): ContactType {
    switch (value) {
      case 'Airport Manager':
        return ContactType.AirportManager;
      case 'Owner':
        return ContactType.Owner;
      default:
        return null;
    }
  }

  /**
   * Formats contact type for display
   * @param {ContactType} type
   * @returns {string}
   */
  static formatContactType(type: ContactType): string {
    switch (type) {
      case ContactType.AirportManager:
        return 'Airport Manager';
      case ContactType.Owner:
        return 'Owner';
      default:
        return null;
    }
  }
}
